// @ts-nocheck

export const localeCodes =  [
  "en",
  "sv"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_3d74f740",
      load: () => import("#nuxt-i18n/3d74f740" /* webpackChunkName: "locale_en_46json_3d74f740" */),
      cache: true
    },
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_f161946b",
      load: () => import("#nuxt-i18n/f161946b" /* webpackChunkName: "locale_sv_46json_f161946b" */),
      cache: true
    },
    {
      key: "locale_sv_46json_15050801",
      load: () => import("#nuxt-i18n/15050801" /* webpackChunkName: "locale_sv_46json_15050801" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    name: "English",
    code: "en",
    language: "en-US"
  },
  {
    name: "Swedish",
    code: "sv",
    language: "sv-SE"
  }
]

